export const config = {
  app: {
    name: process.env.REACT_APP_NAME || 'askSRE Platform',
    version: process.env.REACT_APP_VERSION || '1.0.0'
  },
  
  features: {
    enableChat: process.env.REACT_APP_ENABLE_CHAT === 'true',
    enableSSO: process.env.REACT_APP_ENABLE_SSO === 'true',
    enableSearch: process.env.REACT_APP_ENABLE_SEARCH === 'true',
    enableTileHover: process.env.REACT_APP_ENABLE_TILE_HOVER !== 'false',
    defaultTheme: process.env.REACT_APP_DEFAULT_THEME || 'default',
    autoRedirect: process.env.REACT_APP_AZURE_AUTO_REDIRECT === 'true'
  },

  azure: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    tenantId: process.env.REACT_APP_AZURE_TENANT_ID,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
    scopes: ['openid', 'profile', 'email', 'User.Read']
  },

  api: {
  baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/v1',
  chatUrl: process.env.REACT_APP_CHAT_API_URL || 'http://localhost:8000/v1/chat/completions',
  websocketUrl: process.env.REACT_APP_WEBSOCKET_URL || 'ws://localhost:8000/ws'
},

  chat: {
    maxTokens: parseInt(process.env.CHAT_MAX_TOKENS) || 2000,
    temperature: parseFloat(process.env.CHAT_TEMPERATURE) || 0.7,
    model: process.env.CHAT_MODEL || 'gpt-4'
  },

  cache: {
    useRedis: process.env.REACT_APP_USE_REDIS_CACHE === 'true',
    redisEndpoint: process.env.REACT_APP_REDIS_ENDPOINT || 'http://localhost:6379'
  }
};